var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.labelAlign')
    }
  }, [_c('el-radio-group', {
    staticClass: "radio-group-custom",
    model: {
      value: (_vm.optionModel.labelAlign),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "labelAlign", $$v)
      },
      expression: "optionModel.labelAlign"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "label-left-align"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18nt('designer.setting.leftAlign')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "label-center-align"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18nt('designer.setting.centerAlign')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "label-right-align"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18nt('designer.setting.rightAlign')))])], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71764d56","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-sub-form/sub-form-labelAlign-editor.vue
// module id = null
// module chunks = 